import { FormControlLabel, Typography } from "@mui/material";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { IosSwitch } from "components";
import { clippingOutlineLaserActions, selectLockRotation } from "features/outlineLaser";

import { SettingsPanel } from "./components/SettingsPanel";

export function LaserSettings() {
    const { t } = useTranslation();

    const lockRotation = useAppSelector(selectLockRotation);

    const dispatch = useAppDispatch();

    const toggleLockRotation = (_e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        dispatch(clippingOutlineLaserActions.setLockRotation(checked));
    };

    const toggleFollowClippingPlane = (_e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        dispatch(clippingOutlineLaserActions.setFollowClippingPlane(checked));
    };

    return (
        <SettingsPanel
            summary={
                <Typography fontWeight={600} whiteSpace="nowrap">
                    {t("laserSettings")}
                </Typography>
            }
        >
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="laser-lock-rotation"
                        checked={lockRotation}
                        color="primary"
                        onChange={toggleLockRotation}
                    />
                }
                label={t("lockRotation")}
            />
            <FormControlLabel
                sx={{ whiteSpace: "nowrap" }}
                control={
                    <IosSwitch
                        name="laser-follow-clipping-plane"
                        checked={false}
                        color="primary"
                        onChange={toggleFollowClippingPlane}
                    />
                }
                label={t("followClippingPlane")}
                disabled
            />
        </SettingsPanel>
    );
}
